export default __webpack_public_path__ + "static/media/lightningstormnimbus.5fe9fbc4.png";